// ReviewManagementService.ts
import axios from 'axios';
import { axiosRequest } from '../AxiosService';
import { ReviewsManagementResponse, ReviewsManagementResponseList } from '../../type/response/ReviewsManagementResponse';
import { ReviewManagementType } from '../../pages/HomePage/Components/Review/ReviewManagementType';
import dayjs from 'dayjs';

/**
 * ホームページ用の審査管理データを取得し、表示用の形式に変換して返す
 * @returns 審査管理一覧データ、取得失敗時は空配列
 */
export const getReviewManagementData = async (): Promise<ReviewManagementType[]> => {
  try {
    const response = await axiosRequest<ReviewsManagementResponseList>(
      "/reviewsManagement",
      "GET",
    );

    if (!Array.isArray(response)) {
      console.error("予期しないAPIレスポンス形式です:", response);
      return [];
    }

    // サーバーから取得したデータのフォーマットを変更する
    const formattedReviews: ReviewManagementType[] = response.map((reviewManagementResponse: ReviewsManagementResponse) => {
      const formattedReview: ReviewManagementType = {
        id: reviewManagementResponse.applicationEntry.id,
        applicationNumber: reviewManagementResponse.applicationEntry.number,
        submittedAt: reviewManagementResponse.applicationEntry.submittedAt,  // 申請日
        applicationType: reviewManagementResponse.applicationType.name || "", // 申請種別
        applicationFormat: reviewManagementResponse.application.name || "", // 申請書
        description: reviewManagementResponse.application.description || "",//申請書小分類
        applicationStatus: reviewManagementResponse.applicationEntry.status, // ステータス
        applicant: `${reviewManagementResponse.user.lastName}${reviewManagementResponse.user.firstName}`, // 申請者
        isUrgent: reviewManagementResponse.applicationEntry.isExpress, // 急ぎ申請か否か
        groups: Array.isArray(reviewManagementResponse.groups)//グループ情報
          ? reviewManagementResponse.groups.map(group => group.name)
          : [],
        userProfiles: Array.isArray(reviewManagementResponse.userProfiles) //ユーザプロファイル
          ? reviewManagementResponse.userProfiles.map(profile => ({
            key: profile.key,
            value: profile.value
          })) : [],
        activities: reviewManagementResponse.activities.map((act) => ({ // アクティビティ
            id: act.id,
            status: act.status,
            activityName: act.applicationActivity.activityName,
            order: act.applicationActivity.activityOrder,
            code:act.applicationActivity.code
          })),
      };

      return formattedReview;
    });

    return formattedReviews;

  } catch (error) {
    console.error("審査管理データの取得・整形に失敗しました:", error);
    return [];
  }
};